export const formatNumber = (num) => new Intl.NumberFormat().format(num || 0)

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0)

export const capitalize = (str) => {
  if (!str) return '—'
  return String(str).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
